import { SubscriptionData } from 'src/utilities/types';
import { Subscription } from './Subscription.model';

export interface SubscriptionList {
  hadSubscriptions(): boolean;
  hasActiveSubscription(): boolean;
}

export class SubscriptionListImpl implements SubscriptionList {
  private readonly subscriptions: Subscription[];

  constructor(subscriptions: SubscriptionData[] = []) {
    this.subscriptions = subscriptions.map(
      (subscription) => new Subscription(subscription),
    );
  }

  public hadSubscriptions(): boolean {
    return this.subscriptions.some(
      (subscription) => subscription.isActive() || subscription.isExpired(),
    );
  }

  public hasActiveSubscription(): boolean {
    return this.subscriptions.some((subscription) => subscription.isActive());
  }
}
